import React from 'react';

export const ShutterCenterOpeningPostCenterOpeningPostRight = (
  props: React.SVGProps<SVGSVGElement>,
) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      data-name="Layer 1"
      viewBox="0 0 166.25 59.3"
      width="173"
      {...props}
    >
      <g data-name="Group 83-2">
        <g data-name="Group 483">
          <path
            data-name="Rectangle 166"
            fill="#fff"
            d="M5.49.59h155.26v50.8H5.49z"
          />
          <path
            data-name="Path 2322"
            d="M4.72 51.4V.6a.69.69 0 01.77-.6h155.26c.43 0 .77.26.77.59V51.4c0 .32-.34.58-.77.58H5.49a.68.68 0 01-.77-.58zM160 1.19H6.26v49.62H160z"
            fill="#dcd9d5"
          />
        </g>
        <g data-name="Group 484">
          <path
            data-name="Rectangle 167"
            fill="#fff"
            d="M5.49.59h155.26v50.8H5.49z"
          />
          <path
            data-name="Path 2323"
            d="M4.72 51.4V.6a.69.69 0 01.77-.6h155.26c.43 0 .77.26.77.59V51.4c0 .32-.34.58-.77.58H5.49a.68.68 0 01-.77-.58zM160 1.19H6.26v49.62H160z"
            fill="#dcd9d5"
          />
        </g>
        <g data-name="Group 485" fill="#dcd9d5">
          <path data-name="Rectangle 168" d="M9.9 3.94h146.45v44.1H9.9z" />
          <path
            data-name="Path 2324"
            d="M9.89 48.63c-.42 0-.77-.26-.76-.58V4c0-.32.34-.58.77-.58h146.44c.43 0 .77.26.77.58v44c0 .32-.34.58-.77.58H9.89zM155.58 4.54H10.67v42.92h144.91z"
          />
        </g>
        <path
          data-name="Path 2325"
          d="M.73 52h164.79c.4 0 .73-.25.73-.55a.65.65 0 00-.73-.56H.73a.65.65 0 00-.73.51c0 .3.33.6.73.6z"
          fill="#dcd9d5"
        />
      </g>
      <g data-name="Group 85">
        <g data-name="Group 498">
          <path
            data-name="Rectangle 182"
            fill="#233762"
            d="M34.54 8.28L6.75 2.24v49.49l27.79 6.8V8.28z"
          />
          <path
            data-name="Path 2338"
            d="M6.26 1.53L35 7.76V59.3l-28.78-7zM34 8.8L7.24 3v48.24L34 57.79z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 499">
          <path
            data-name="Rectangle 183"
            fill="#233762"
            d="M31.54 12.94L9.49 8.09v3.56l22.05 4.9v-3.61z"
          />
          <path
            data-name="Path 2339"
            d="M9.24 7.72l22.55 5V17L9.24 12zm22 5.49L9.75 8.47v2.92l21.52 4.77z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 500">
          <path
            data-name="Rectangle 184"
            fill="#233762"
            d="M31.54 16.55l-22.05-4.9v3.57l22.05 4.94v-3.61z"
          />
          <path
            data-name="Path 2340"
            d="M9.24 11.28l22.55 5v4.27L9.24 15.49zm22 5.54L9.75 12v3l21.52 4.81z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 501">
          <path
            data-name="Rectangle 185"
            fill="#233762"
            d="M31.54 20.16L9.49 15.22v3.58l22.05 4.97v-3.61z"
          />
          <path
            data-name="Path 2341"
            d="M9.24 14.85l22.55 5v4.27L9.24 19.06zm22 5.58L9.75 15.61v2.92l21.52 4.86z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 502">
          <path
            data-name="Rectangle 186"
            fill="#233762"
            d="M31.54 23.8L9.49 18.82v3.57l22.05 5.02V23.8z"
          />
          <path
            data-name="Path 2342"
            d="M9.24 18.44l22.55 5.09v4.27L9.24 22.65zm22 5.63L9.75 19.2v2.92L31.27 27z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 503">
          <path
            data-name="Rectangle 187"
            fill="#233762"
            d="M31.54 27.41L9.49 22.39v3.56l22.05 5.07v-3.61z"
          />
          <path
            data-name="Path 2343"
            d="M9.24 22l22.55 5.13v4.27L9.24 26.22zm22 5.67l-21.49-4.9v2.92l21.52 4.94z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 504">
          <path
            data-name="Rectangle 188"
            fill="#233762"
            d="M31.54 31.02L9.49 25.95v3.57l22.05 5.11v-3.61z"
          />
          <path
            data-name="Path 2344"
            d="M9.24 25.57l22.55 5.18V35L9.24 29.79zm22 5.72l-21.52-5v2.92l21.52 5z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 505">
          <path
            data-name="Rectangle 189"
            fill="#233762"
            d="M31.54 34.63L9.49 29.52v3.57l22.05 5.14v-3.6z"
          />
          <path
            data-name="Path 2345"
            d="M9.24 29.14l22.55 5.23v4.26L9.24 33.35zm22 5.76l-21.52-5v2.93l21.52 5z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 506">
          <path
            data-name="Rectangle 190"
            fill="#233762"
            d="M31.54 38.23L9.49 33.09v3.57l22.05 5.19v-3.62z"
          />
          <path
            data-name="Path 2346"
            d="M9.24 32.71L31.79 38v4.27L9.24 36.92zm22 5.8l-21.52-5v2.92l21.52 5.08z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 507">
          <path
            data-name="Rectangle 191"
            fill="#233762"
            d="M31.54 41.85L9.49 36.66v3.56l22.05 5.25v-3.62z"
          />
          <path
            data-name="Path 2347"
            d="M9.24 36.28l22.55 5.31v4.27L9.24 40.49zm22 5.84L9.75 37v3l21.52 5.12z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 508">
          <path
            data-name="Rectangle 192"
            fill="#233762"
            d="M31.54 45.48L9.49 40.24v3.57l22.05 5.29v-3.62z"
          />
          <path
            data-name="Path 2348"
            d="M9.24 39.87l22.55 5.36v4.27L9.24 44.08zm22 5.89L9.75 40.63v2.92l21.52 5.17z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 509">
          <path
            data-name="Rectangle 193"
            fill="#233762"
            d="M31.54 49.1L9.49 43.81v3.57l22.05 5.34V49.1z"
          />
          <path
            data-name="Path 2349"
            d="M9.24 43.43l22.55 5.41v4.27L9.24 47.65zm22 5.94L9.75 44.2v2.92l21.52 5.21z"
            fill="#fff"
          />
        </g>
        <path
          data-name="Rectangle 194"
          fill="#fff"
          d="M21.07 10.63l-1.44-.32v39.53l1.44.35V10.63z"
        />
      </g>
      <g data-name="Group 85-2">
        <g data-name="Group 498-2">
          <path
            data-name="Rectangle 182-2"
            fill="#233762"
            d="M37.87 8.28l27.79-6.04v49.49l-27.79 6.8V8.28z"
          />
          <path
            data-name="Path 2338-2"
            d="M66.15 52.25l-28.78 7V7.76l28.78-6.23zm-27.78 5.54l26.8-6.55V3l-26.8 5.8z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 499-2">
          <path
            data-name="Rectangle 183-2"
            fill="#233762"
            d="M40.88 12.94l22.03-4.85v3.56l-22.03 4.9v-3.61z"
          />
          <path
            data-name="Path 2339-2"
            d="M63.17 11.93l-22.55 5v-4.26l22.55-4.95zm-22 4.23l21.52-4.77V8.47l-21.56 4.74z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 500-2">
          <path
            data-name="Rectangle 184-2"
            fill="#233762"
            d="M40.88 16.55l22.03-4.9v3.57l-22.03 4.94v-3.61z"
          />
          <path
            data-name="Path 2340-2"
            d="M63.17 15.49l-22.55 5.06v-4.27l22.55-5zm-22 4.28L62.66 15v-3l-21.53 4.82z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 501-2">
          <path
            data-name="Rectangle 185-2"
            fill="#233762"
            d="M40.88 20.16l22.03-4.94v3.58l-22.03 4.97v-3.61z"
          />
          <path
            data-name="Path 2341-2"
            d="M63.17 19.06l-22.55 5.1v-4.27l22.55-5zm-22 4.33l21.52-4.86v-2.92l-21.56 4.82z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 502-2">
          <path
            data-name="Rectangle 186-2"
            fill="#233762"
            d="M40.88 23.8l22.03-4.98v3.57l-22.03 5.02V23.8z"
          />
          <path
            data-name="Path 2342-2"
            d="M63.17 22.65L40.62 27.8v-4.27l22.55-5.09zM41.14 27l21.52-4.9v-2.9l-21.53 4.87z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 503-2">
          <path
            data-name="Rectangle 187-2"
            fill="#233762"
            d="M40.88 27.41l22.03-5.02v3.56l-22.03 5.07v-3.61z"
          />
          <path
            data-name="Path 2343-2"
            d="M63.17 26.22l-22.55 5.19v-4.27L63.17 22zm-22 4.41l21.52-4.94v-2.92l-21.56 4.91z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 504-2">
          <path
            data-name="Rectangle 188-2"
            fill="#233762"
            d="M40.88 31.02l22.03-5.07v3.57l-22.03 5.11v-3.61z"
          />
          <path
            data-name="Path 2344-2"
            d="M63.17 29.79L40.62 35v-4.25l22.55-5.18zm-22 4.46l21.52-5v-2.91l-21.53 5z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 505-2">
          <path
            data-name="Rectangle 189-2"
            fill="#233762"
            d="M40.88 34.63l22.03-5.11v3.57l-22.03 5.14v-3.6z"
          />
          <path
            data-name="Path 2345-2"
            d="M63.17 33.35l-22.55 5.28v-4.26l22.55-5.23zm-22 4.51l21.52-5v-3l-21.53 5z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 506-2">
          <path
            data-name="Rectangle 190-2"
            fill="#233762"
            d="M40.88 38.23l22.03-5.14v3.57l-22.03 5.19v-3.62z"
          />
          <path
            data-name="Path 2346-2"
            d="M63.17 36.92l-22.55 5.33V38l22.55-5.3zm-22 4.55l21.52-5.08v-2.92l-21.53 5z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 507-2">
          <path
            data-name="Rectangle 191-2"
            fill="#233762"
            d="M40.88 41.85l22.03-5.19v3.56l-22.03 5.25v-3.62z"
          />
          <path
            data-name="Path 2347-2"
            d="M63.17 40.49l-22.55 5.37v-4.27l22.55-5.31zm-22 4.59L62.66 40v-3l-21.53 5.12z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 508-2">
          <path
            data-name="Rectangle 192-2"
            fill="#233762"
            d="M40.88 45.48l22.03-5.24v3.57L40.88 49.1v-3.62z"
          />
          <path
            data-name="Path 2348-2"
            d="M63.17 44.08L40.62 49.5v-4.27l22.55-5.36zm-22 4.64l21.52-5.17v-2.92l-21.56 5.13z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 509-2">
          <path
            data-name="Rectangle 193-2"
            fill="#233762"
            d="M40.88 49.1l22.03-5.29v3.57l-22.03 5.34V49.1z"
          />
          <path
            data-name="Path 2349-2"
            d="M63.17 47.65l-22.55 5.46v-4.27l22.55-5.41zm-22 4.68l21.52-5.21V44.2l-21.56 5.17z"
            fill="#fff"
          />
        </g>
        <path
          data-name="Rectangle 194-2"
          fill="#fff"
          d="M51.34 10.63l1.44-.32v39.53l-1.44.35V10.63z"
        />
      </g>
      <g data-name="Group 85-3">
        <g data-name="Group 498-3">
          <path
            data-name="Rectangle 182-3"
            fill="#233762"
            d="M95.69 8.28L67.9 2.24v49.49l27.79 6.8V8.28z"
          />
          <path
            data-name="Path 2338-3"
            d="M67.41 1.53l28.78 6.23V59.3l-28.78-7zM95.18 8.8L68.38 3v48.24l26.8 6.55z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 499-3">
          <path
            data-name="Rectangle 183-3"
            fill="#233762"
            d="M92.68 12.94L70.64 8.09v3.56l22.04 4.9v-3.61z"
          />
          <path
            data-name="Path 2339-3"
            d="M70.39 7.72l22.55 5V17l-22.55-5zm22 5.49l-21.5-4.74v2.92l21.53 4.77z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 500-3">
          <path
            data-name="Rectangle 184-3"
            fill="#233762"
            d="M92.68 16.55l-22.04-4.9v3.57l22.04 4.94v-3.61z"
          />
          <path
            data-name="Path 2340-3"
            d="M70.39 11.28l22.55 5v4.27l-22.55-5.06zm22 5.54L70.89 12v3l21.53 4.81z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 501-3">
          <path
            data-name="Rectangle 185-3"
            fill="#233762"
            d="M92.68 20.16l-22.04-4.94v3.58l22.04 4.97v-3.61z"
          />
          <path
            data-name="Path 2341-3"
            d="M70.39 14.85l22.55 5v4.27L70.39 19zm22 5.58l-21.5-4.82v2.92l21.53 4.86z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 502-3">
          <path
            data-name="Rectangle 186-3"
            fill="#233762"
            d="M92.68 23.8l-22.04-4.98v3.57l22.04 5.02V23.8z"
          />
          <path
            data-name="Path 2342-3"
            d="M70.39 18.44l22.55 5.09v4.27l-22.55-5.15zm22 5.63l-21.5-4.87v2.92L92.42 27z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 503-3">
          <path
            data-name="Rectangle 187-3"
            fill="#233762"
            d="M92.68 27.41l-22.04-5.02v3.56l22.04 5.07v-3.61z"
          />
          <path
            data-name="Path 2343-3"
            d="M70.39 22l22.55 5.13v4.27l-22.55-5.18zm22 5.67l-21.5-4.91v2.92l21.53 4.94z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 504-3">
          <path
            data-name="Rectangle 188-3"
            fill="#233762"
            d="M92.68 31.02l-22.04-5.07v3.57l22.04 5.11v-3.61z"
          />
          <path
            data-name="Path 2344-3"
            d="M70.39 25.57l22.55 5.18V35l-22.55-5.21zm22 5.72l-21.53-5v2.92l21.53 5z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 505-3">
          <path
            data-name="Rectangle 189-3"
            fill="#233762"
            d="M92.68 34.63l-22.04-5.11v3.57l22.04 5.14v-3.6z"
          />
          <path
            data-name="Path 2345-3"
            d="M70.39 29.14l22.55 5.23v4.26l-22.55-5.28zm22 5.76l-21.53-5v2.93l21.53 5z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 506-3">
          <path
            data-name="Rectangle 190-3"
            fill="#233762"
            d="M92.68 38.23l-22.04-5.14v3.57l22.04 5.19v-3.62z"
          />
          <path
            data-name="Path 2346-3"
            d="M70.39 32.71L92.94 38v4.27l-22.55-5.35zm22 5.8l-21.53-5v2.92l21.53 5.08z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 507-3">
          <path
            data-name="Rectangle 191-3"
            fill="#233762"
            d="M92.68 41.85l-22.04-5.19v3.56l22.04 5.25v-3.62z"
          />
          <path
            data-name="Path 2347-3"
            d="M70.39 36.28l22.55 5.31v4.27l-22.55-5.37zm22 5.84L70.89 37v3l21.53 5.12z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 508-3">
          <path
            data-name="Rectangle 192-3"
            fill="#233762"
            d="M92.68 45.48l-22.04-5.24v3.57l22.04 5.29v-3.62z"
          />
          <path
            data-name="Path 2348-3"
            d="M70.39 39.87l22.55 5.36v4.27l-22.55-5.42zm22 5.89l-21.5-5.13v2.92l21.53 5.17z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 509-3">
          <path
            data-name="Rectangle 193-3"
            fill="#233762"
            d="M92.68 49.1l-22.04-5.29v3.57l22.04 5.34V49.1z"
          />
          <path
            data-name="Path 2349-3"
            d="M70.39 43.43l22.55 5.41v4.27l-22.55-5.46zm22 5.94l-21.5-5.17v2.92l21.53 5.21z"
            fill="#fff"
          />
        </g>
        <path
          data-name="Rectangle 194-3"
          fill="#fff"
          d="M82.22 10.63l-1.44-.32v39.53l1.44.35V10.63z"
        />
      </g>
      <g data-name="Group 85-4">
        <g data-name="Group 498-4">
          <path
            data-name="Rectangle 182-4"
            fill="#233762"
            d="M99.02 8.28l27.79-6.04v49.49l-27.79 6.8V8.28z"
          />
          <path
            data-name="Path 2338-4"
            d="M127.29 52.25l-28.78 7V7.76l28.78-6.23zm-27.77 5.54l26.8-6.55V3l-26.8 5.8z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 499-4">
          <path
            data-name="Rectangle 183-4"
            fill="#233762"
            d="M102.02 12.94l22.04-4.85v3.56l-22.04 4.9v-3.61z"
          />
          <path
            data-name="Path 2339-4"
            d="M124.32 11.93l-22.56 5v-4.26l22.56-4.95zm-22 4.23l21.53-4.77V8.47l-21.57 4.74z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 500-4">
          <path
            data-name="Rectangle 184-4"
            fill="#233762"
            d="M102.02 16.55l22.04-4.9v3.57l-22.04 4.94v-3.61z"
          />
          <path
            data-name="Path 2340-4"
            d="M124.32 15.49l-22.56 5.06v-4.27l22.56-5zm-22 4.28L123.81 15v-3l-21.53 4.78z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 501-4">
          <path
            data-name="Rectangle 185-4"
            fill="#233762"
            d="M102.02 20.16l22.04-4.94v3.58l-22.04 4.97v-3.61z"
          />
          <path
            data-name="Path 2341-4"
            d="M124.32 19.06l-22.56 5.1v-4.27l22.56-5zm-22 4.33l21.53-4.86v-2.92l-21.53 4.82z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 502-4">
          <path
            data-name="Rectangle 186-4"
            fill="#233762"
            d="M102.02 23.8l22.04-4.98v3.57l-22.04 5.02V23.8z"
          />
          <path
            data-name="Path 2342-4"
            d="M124.32 22.65l-22.56 5.15v-4.27l22.56-5.09zm-22 4.37l21.53-4.9V19.2l-21.53 4.87z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 503-4">
          <path
            data-name="Rectangle 187-4"
            fill="#233762"
            d="M102.02 27.41l22.04-5.02v3.56l-22.04 5.07v-3.61z"
          />
          <path
            data-name="Path 2343-4"
            d="M124.32 26.22l-22.56 5.19v-4.27L124.32 22zm-22 4.41l21.53-4.94v-2.92l-21.53 4.91z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 504-4">
          <path
            data-name="Rectangle 188-4"
            fill="#233762"
            d="M102.02 31.02l22.04-5.07v3.57l-22.04 5.11v-3.61z"
          />
          <path
            data-name="Path 2344-4"
            d="M124.32 29.79L101.76 35v-4.25l22.56-5.18zm-22 4.46l21.53-5v-2.91l-21.53 5z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 505-4">
          <path
            data-name="Rectangle 189-4"
            fill="#233762"
            d="M102.02 34.63l22.04-5.11v3.57l-22.04 5.14v-3.6z"
          />
          <path
            data-name="Path 2345-4"
            d="M124.32 33.35l-22.56 5.28v-4.26l22.56-5.23zm-22 4.51l21.53-5v-3l-21.53 5z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 506-4">
          <path
            data-name="Rectangle 190-4"
            fill="#233762"
            d="M102.02 38.23l22.04-5.14v3.57l-22.04 5.19v-3.62z"
          />
          <path
            data-name="Path 2346-4"
            d="M124.32 36.92l-22.56 5.33V38l22.56-5.27zm-22 4.55l21.53-5.08v-2.92l-21.53 5z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 507-4">
          <path
            data-name="Rectangle 191-4"
            fill="#233762"
            d="M102.02 41.85l22.04-5.19v3.56l-22.04 5.25v-3.62z"
          />
          <path
            data-name="Path 2347-4"
            d="M124.32 40.49l-22.56 5.37v-4.27l22.56-5.31zm-22 4.59L123.81 40v-3l-21.53 5.08z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 508-4">
          <path
            data-name="Rectangle 192-4"
            fill="#233762"
            d="M102.02 45.48l22.04-5.24v3.57l-22.04 5.29v-3.62z"
          />
          <path
            data-name="Path 2348-4"
            d="M124.32 44.08l-22.56 5.42v-4.27l22.56-5.36zm-22 4.64l21.53-5.17v-2.92l-21.53 5.13z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 509-4">
          <path
            data-name="Rectangle 193-4"
            fill="#233762"
            d="M102.02 49.1l22.04-5.29v3.57l-22.04 5.34V49.1z"
          />
          <path
            data-name="Path 2349-4"
            d="M124.32 47.65l-22.56 5.46v-4.27l22.56-5.41zm-22 4.68l21.53-5.21V44.2l-21.53 5.17z"
            fill="#fff"
          />
        </g>
        <path
          data-name="Rectangle 194-4"
          fill="#fff"
          d="M112.48 10.63l1.45-.32v39.53l-1.45.35V10.63z"
        />
      </g>
      <g data-name="Group 85-5">
        <g data-name="Group 498-5">
          <path
            data-name="Rectangle 182-5"
            fill="#233762"
            d="M131.25 8.15l27.78-6.02v49.5l-27.78 6.79V8.15z"
          />
          <path
            data-name="Path 2338-5"
            d="M159.52 52.13l-28.78 7V7.64l28.78-6.23zm-27.77 5.54l26.8-6.55V2.86l-26.8 5.82z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 499-5">
          <path
            data-name="Rectangle 183-5"
            fill="#233762"
            d="M134.25 12.81l22.04-4.84v3.57l-22.04 4.89v-3.62z"
          />
          <path
            data-name="Path 2339-5"
            d="M156.55 11.81l-22.56 5v-4.26l22.56-5zm-22 4.24L156 11.28V8.36l-21.53 4.73z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 500-5">
          <path
            data-name="Rectangle 184-5"
            fill="#233762"
            d="M134.25 16.43l22.04-4.89v3.57l-22.04 4.94v-3.62z"
          />
          <path
            data-name="Path 2340-5"
            d="M156.55 15.38l-22.55 5v-4.22l22.56-5zm-22 4.28L156 14.84v-2.92l-21.53 4.78z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 501-5">
          <path
            data-name="Rectangle 185-5"
            fill="#233762"
            d="M134.25 20.05l22.04-4.94v3.57l-22.04 4.98v-3.61z"
          />
          <path
            data-name="Path 2341-5"
            d="M156.55 19L134 24v-4.22l22.56-5zm-22 4.32L156 18.41v-2.92l-21.49 4.82z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 502-5">
          <path
            data-name="Rectangle 186-5"
            fill="#233762"
            d="M134.25 23.68l22.04-4.98v3.57l-22.04 5.02v-3.61z"
          />
          <path
            data-name="Path 2342-5"
            d="M156.55 22.54L134 27.68v-4.26l22.56-5.09zm-22 4.37L156 22v-2.91L134.47 24z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 503-5">
          <path
            data-name="Rectangle 187-5"
            fill="#233762"
            d="M134.25 27.29l22.04-5.02v3.57l-22.04 5.07v-3.62z"
          />
          <path
            data-name="Path 2343-5"
            d="M156.55 26.1L134 31.29V27l22.56-5.14zm-22 4.42l21.53-5v-2.87l-21.53 4.91z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 504-5">
          <path
            data-name="Rectangle 188-5"
            fill="#233762"
            d="M134.25 30.91l22.04-5.07v3.57l-22.04 5.11v-3.61z"
          />
          <path
            data-name="Path 2344-5"
            d="M156.55 29.67L134 34.9v-4.26l22.56-5.18zm-22 4.46l21.53-5v-2.91l-21.53 5z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 505-5">
          <path
            data-name="Rectangle 189-5"
            fill="#233762"
            d="M134.25 34.52l22.04-5.11v3.56l-22.04 5.16v-3.61z"
          />
          <path
            data-name="Path 2345-5"
            d="M156.55 33.24L134 38.52v-4.27L156.55 29zm-22 4.5l21.53-5v-3l-21.53 5z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 506-5">
          <path
            data-name="Rectangle 190-5"
            fill="#233762"
            d="M134.25 38.13l22.04-5.16v3.56l-22.04 5.2v-3.6z"
          />
          <path
            data-name="Path 2346-5"
            d="M156.55 36.8L134 42.13v-4.27l22.56-5.27zm-22 4.55L156 36.28v-2.92l-21.53 5z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 507-5">
          <path
            data-name="Rectangle 191-5"
            fill="#233762"
            d="M134.25 41.73l22.04-5.2v3.57l-22.04 5.24v-3.61z"
          />
          <path
            data-name="Path 2347-5"
            d="M156.55 40.37L134 45.74v-4.26l22.56-5.32zm-22 4.59L156 39.84v-2.92L134.51 42z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 508-5">
          <path
            data-name="Rectangle 192-5"
            fill="#233762"
            d="M134.25 45.38l22.04-5.25v3.57l-22.04 5.28v-3.6z"
          />
          <path
            data-name="Path 2348-5"
            d="M156.55 44L134 49.38v-4.27l22.56-5.36zm-22 4.64l21.45-5.2v-2.92l-21.53 5.12z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 509-5">
          <path
            data-name="Rectangle 193-5"
            fill="#233762"
            d="M134.25 48.98l22.04-5.28v3.57l-22.04 5.32v-3.61z"
          />
          <path
            data-name="Path 2349-5"
            d="M156.55 47.53L134 53v-4.28l22.56-5.4zm-22 4.68L156 47v-2.91l-21.53 5.17z"
            fill="#fff"
          />
        </g>
        <path
          data-name="Rectangle 194-5"
          fill="#fff"
          d="M144.72 10.52l1.44-.31v39.51l-1.44.34V10.52z"
        />
      </g>
      <path
        fill="#233762"
        d="M66.15 3.36h1.26v45.27h-1.26zM127.29 3.36h1.26v45.27h-1.26z"
      />
    </svg>
  );
};
